import { useEffect, useState } from 'react';
import { OPEN_ANALYTICS_SETTINGS_EVENT, readAnalyticsConsent, saveAnalyticsConsent } from '../../analytics/googleAnalytics';

export function AnalyticsConsent() {
  const [open, setOpen] = useState(() => readAnalyticsConsent() === null);

  useEffect(() => {
    function showSettings() {
      setOpen(true);
    }
    window.addEventListener(OPEN_ANALYTICS_SETTINGS_EVENT, showSettings);
    return () => window.removeEventListener(OPEN_ANALYTICS_SETTINGS_EVENT, showSettings);
  }, []);

  function choose(consent: 'granted' | 'denied') {
    saveAnalyticsConsent(consent);
    setOpen(false);
  }

  if (!open) return null;

  return <aside className="analytics-consent" role="dialog" aria-labelledby="analytics-consent-title">
    <div>
      <p className="analytics-consent-kicker">DITT VALG</p>
      <h2 id="analytics-consent-title">Velg hvordan bruken måles</h2>
      <p>Google-taggen måler sidevisninger uten analyseinformasjonskapsler. Med tillatelse kan Google Analytics også kjenne igjen tilbakevendende besøk. Vi sender ikke navn, e-post, øvelsessvar eller søkeord.</p>
      <a href="/personvern#analyse">Les om personvern og analyse</a>
    </div>
    <div className="analytics-consent-actions">
      <button className="analytics-decline" onClick={() => choose('denied')}>Uten informasjonskapsler</button>
      <button className="analytics-accept" onClick={() => choose('granted')}>Tillat analyse</button>
    </div>
  </aside>;
}
